import * as MT from "./mutationTypes";
import Auth from "@/packages/auth";

export default {
  [MT.SET_EXAMPLE_STATE]: (state, data) => (state.exampleState = data),
  [MT.STORE_LOADER]: (state, data) => (state.globalLoader = data),
  [MT.SET_USER]: (state, data) => (state.userState = data),
  [MT.GET_USER]: state => {
    return (state.userState = JSON.parse(Auth.getUser()));
  },
  [MT.GET_ACCOUNT]: state => {
    return (state.accountDetailsState = JSON.parse(Auth.getAccount()));
  },
  [MT.SET_LOGIN_ERROR]: (state, data) => {
    if (data.message) {
      state.loginErrorState = { data: [data.message], error: true };
    }
    if (data.errors) {
      state.loginErrorState = { data: [].concat.apply([], Object.values(data.errors)), error: true };
    }
    return state.loginErrorState;
  },
  [MT.SET_REGISTRATION_ERROR]: (state, data) => {
    if (data.message) {
      state.registrationErrorState = { data: [data.message], error: true };
    }
    if (data.errors) {
      state.registrationErrorState = { data: [].concat.apply([], Object.values(data.errors)), error: true };
    }
    return state.registrationErrorState;
  },
  [MT.STORE_PENDING_ORDERS_DATA]: (state, data) => {
    state.pendingOrdersState = data.pendingOrders;
    state.dashboardStatisticalDataState = data.statisticalData;
    return;
  },
  [MT.CUSTOMER_FILTER]: (state, data) => {
    state.customerFilterState = data;
    return;
  },
  [MT.COMPANY_FILTER]: (state, data) => {
    state.companyFilterState = data;
    return;
  },
  [MT.STATUS_FILTER]: (state, data) => {
    state.statusFilterState = data;
    return;
  },
  [MT.DATE_FILTER]: (state, data) => {
    if (data.entity === "from") {
      return (state.fromDateFilterState = data.date);
    }
    return (state.toDateFilterState = data.date);
  },
  [MT.STORE_CUSTOMER_DETAILS]: (state, data) => {
    state.customerState = data.customer;
    state.customerOrdersState = data.orders;
    return;
  },
  [MT.STORE_PLANS]: (state, data) => {
    state.planState = data;
    return;
  },
  [MT.UPDATE_USER]: (state, data) => {
    state.userState = data;
    return;
  },
  [MT.ORDERS_MANIPULATED]: (state, data) => {
    if (!data || !Array.isArray(data)) {
      state.dashboardStatisticalDataState = { totalAmountOwed: 0, totalAmountPastDue: 0 };
      return;
    }
    const metrics = data.reduce(
      (collection, order) => {
        if (
          order.days_until_due.sign !== undefined &&
          order.days_until_due.sign !== null &&
          order.days_until_due.sign === "danger"
        ) {
          collection.totalAmountPastDue += parseFloat(order.order_amount);
        }
        collection.totalAmountOwed += parseFloat(order.order_amount);
        return collection;
      },
      { totalAmountOwed: 0, totalAmountPastDue: 0 }
    );
    metrics.totalAmountOwed = metrics.totalAmountOwed.toFixed(2);
    metrics.totalAmountPastDue = metrics.totalAmountPastDue.toFixed(2);
    state.dashboardStatisticalDataState = metrics;
    return;
  },
  [MT.ONBOARDING_VERIFIED]: (state, data) => {
    state.userState = data.user;
    Auth.setUser(data.user);
    return;
  },
  [MT.STORE_ACCOUNT_DETAILS]: (state, response) => {
    state.accountDetailsState = response.data;
    Auth.destroyAccount();
    Auth.setAccount(state.accountDetailsState);
    return;
  },
  [MT.SET_ACCOUNT_COMPANY]: (state, response) => {
    state.accountDetailsState.company = response.value;
    return;
  },
  [MT.SET_ACCOUNT_ADDRESS]: (state, response) => {
    state.accountDetailsState.address = response.value;
    return;
  },
  [MT.SET_ACCOUNT_INSTRUCTIONS]: (state, response) => {
    state.accountDetailsState.instructions = response.value;
    return;
  },
  [MT.SET_ACCOUNT_EMAIL_SIGNATURE]: (state, response) => {
    state.accountDetailsState.emailSignature = response.value;
    return;
  },
  [MT.ENABLE_SEND_INVOICE_ON_PENDING_ORDER_CREATION_SETTING]: state => {
    state.accountDetailsState.settings.sendInvoiceOnPendingOrderCreation = true;
    Auth.destroyAccount();
    Auth.setAccount(state.accountDetailsState);
    return;
  },
  [MT.DISABLE_SEND_INVOICE_ON_PENDING_ORDER_CREATION_SETTING]: state => {
    state.accountDetailsState.settings.sendInvoiceOnPendingOrderCreation = false;
    Auth.destroyAccount();
    Auth.setAccount(state.accountDetailsState);
    return;
  },
  [MT.ENABLE_SEND_STRIPE_PAYMENT_LINK_IN_EMAIL]: state => {
    state.accountDetailsState.settings.sendStripePaymentLinkInEmail = true;
    Auth.destroyAccount();
    Auth.setAccount(state.accountDetailsState);
    return;
  },
  [MT.DISABLE_SEND_STRIPE_PAYMENT_LINK_IN_EMAIL]: state => {
    state.accountDetailsState.settings.sendStripePaymentLinkInEmail = false;
    Auth.destroyAccount();
    Auth.setAccount(state.accountDetailsState);
    return;
  },
  [MT.ENABLE_SEND_SHOPIFY_CHECKOUT_PAYMENT_LINK_IN_EMAIL]: state => {
    state.accountDetailsState.settings.sendShopifyCheckoutPaymentLinkInEmail = true;
    Auth.destroyAccount();
    Auth.setAccount(state.accountDetailsState);
    return;
  },
  [MT.DISABLE_SEND_SHOPIFY_CHECKOUT_PAYMENT_LINK_IN_EMAIL]: state => {
    state.accountDetailsState.settings.sendShopifyCheckoutPaymentLinkInEmail = false;
    Auth.destroyAccount();
    Auth.setAccount(state.accountDetailsState);
    return;
  },
  [MT.CALCULATE_NET_PAYMENT_DAYS_FROM_FULFILLMENT_DATE_SETTING]: state => {
    state.accountDetailsState.settings.calculateNetPaymentDaysFromFulfillmentDate = true;
    Auth.destroyAccount();
    Auth.setAccount(state.accountDetailsState);
    return;
  },
  [MT.REMOVE_CALCULATE_NET_PAYMENT_DAYS_FROM_FULFILLMENT_DATE_SETTING]: state => {
    state.accountDetailsState.settings.calculateNetPaymentDaysFromFulfillmentDate = false;
    Auth.destroyAccount();
    Auth.setAccount(state.accountDetailsState);
    return;
  },
  [MT.SET_ACCOUNT_INVOICE_TEMPLATE]: (state, response) => {
    state.accountDetailsState.settings.selectedInvoiceTemplate = response.value;
    return;
  },
  [MT.SET_LOGO]: (state, response) => {
    state.accountDetailsState.settings.logoUrl = response.value;
    return;
  },
  [MT.USER_NOTIFIED_FOR_EXHAUSTED_LIMIT]: state => {
    state.orderLimitExhaustedNotification += 1;
    return;
  },
  [MT.DECREMENT_ORDER_LIMIT]: state => {
    if (
      state.accountDetailsState.settings.remainingAllowedOrdersCount !== null &&
      state.accountDetailsState.settings.remainingAllowedOrdersCount > 0
    ) {
      state.accountDetailsState.settings.remainingAllowedOrdersCount -= 1;
      Auth.destroyAccount();
      Auth.setAccount(state.accountDetailsState);
    }
    return;
  },
  [MT.SET_NEW_SCOPE_ACCEPTED]: state => {
    state.accountDetailsState.isNewScopesAvailable = false;
    Auth.destroyAccount();
    Auth.setAccount(state.accountDetailsState);
    return;
  },
  [MT.ADD_CUSTOM_NET_TERM]: (state, data) => {
    delete data["account_id"];
    delete data["created_at"];
    delete data["updated_at"];
    delete data["deleted_at"];
    state.accountDetailsState.customNetTerms.push(data);
    Auth.destroyAccount();
    Auth.setAccount(state.accountDetailsState);
    return;
  },
  [MT.REMOVE_CUSTOM_NET_TERM]: (state, data) => {
    const index = state.accountDetailsState.customNetTerms.map(item => item.id).indexOf(data.id);
    state.accountDetailsState.customNetTerms.splice(index, 1);
    Auth.destroyAccount();
    Auth.setAccount(state.accountDetailsState);
    return;
  },
  [MT.ADD_EMAIL_MULTIPLE_EMAIL_ADDRESS]: (state, data) => {
    delete data["account_id"];
    delete data["created_at"];
    delete data["updated_at"];
    delete data["deleted_at"];
    state.accountDetailsState.multipleEmailAddresses.push(data);
    Auth.destroyAccount();
    Auth.setAccount(state.accountDetailsState);
    return;
  },
  [MT.REMOVE_EMAIL_MULTIPLE_EMAIL_ADDRESS]: (state, data) => {
    const index = state.accountDetailsState.multipleEmailAddresses.map(item => item.id).indexOf(data.id);
    state.accountDetailsState.multipleEmailAddresses.splice(index, 1);
    Auth.destroyAccount();
    Auth.setAccount(state.accountDetailsState);
    return;
  },
  [MT.ENABLE_DISABLE_EMAIL_MULTIPLE_EMAIL_ADDRESS]: (state, data) => {
    state.accountDetailsState.multipleEmailAddresses.map(item => {
      if (item.id === data.id) {
        item.status = !item.status;
      }
      return item;
    });
    Auth.destroyAccount();
    Auth.setAccount(state.accountDetailsState);
    return;
  },
  [MT.STATEMENT_FOR_CUSTOMERS]: state => {
    state.accountDetailsState.settings.statementForCustomers.isSettingEnabled = true;
    Auth.destroyAccount();
    Auth.setAccount(state.accountDetailsState);
    return;
  },
  [MT.REMOVE_STATEMENT_FOR_CUSTOMERS]: state => {
    state.accountDetailsState.settings.statementForCustomers.isSettingEnabled = false;
    Auth.destroyAccount();
    Auth.setAccount(state.accountDetailsState);
    return;
  },
  [MT.UPDATE_STATEMENT_DAYS]: (state, data) => {
    state.accountDetailsState.settings.statementForCustomers.days = data;
    return;
  },
  [MT.RESET_ACCOUNT_FRONTEND]: state => {
    Auth.destroyAccount();
    Auth.setAccount(state.accountDetailsState);
    return;
  },
  [MT.ADD_PERIODIC_UPDATES]: state => {
    state.accountDetailsState.settings.periodicUpdates = true;
    Auth.destroyAccount();
    Auth.setAccount(state.accountDetailsState);
    return;
  },
  [MT.REMOVE_PERIODIC_UPDATES]: state => {
    state.accountDetailsState.settings.periodicUpdates = false;
    Auth.destroyAccount();
    Auth.setAccount(state.accountDetailsState);
    return;
  }
};
